import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-overline" }
const _hoisted_3 = { ref: "pre" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getPadding())
  }, [
    _createVNode(_component_v_card, {
      class: _normalizeClass(_ctx.$vuetify.display.smAndDown ? 'msg mobile my-4' : 'msg my-4')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (_ctx.summaryFormatted !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.getTime(_ctx.timestamp)), 1),
                  _createElementVNode("pre", _hoisted_3, [
                    _createElementVNode("code", {
                      class: "chat-text language-markdown",
                      innerHTML: _ctx.summaryFormatted
                    }, null, 8, _hoisted_4)
                  ], 512)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_v_card, {
      class: "msg clickable",
      onClick: _ctx.onFullAnalysisClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          class: "expand-btn",
          icon: "mdi-chevron-down",
          variant: "text",
          size: "x-large"
        }),
        _createVNode(_component_v_card_title, { class: "clickable d-block mr-8 mb-n1" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Full Analysis ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 2))
}